import { render, staticRenderFns } from "./AgentTransactionsReportTrademarkOppositionList.vue?vue&type=template&id=5390237d&"
import script from "./AgentTransactionsReportTrademarkOppositionList.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionsReportTrademarkOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionsReportTrademarkOppositionList.vue?vue&type=style&index=0&id=5390237d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports